"use client"

import { ExternalLink } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ExternalLinkIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ExternalLinkIcon = component(Icon)({ as: ExternalLink })
